import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import { useAuthContext } from "../../../context/AuthContext";
import { KeyValue } from "../../../models/key-value";
import { IStudy, IVisit } from "../../../models/study.interface";
import studiesService from "../../../services/studies.service";
import SelectFormInput from "../../Shared/SelectInput/SelectFormInput";

interface IStudyFormInput {
  study: string;
}

type StudySelectFormInputProps = {
  control: Control<IStudyFormInput, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
  onStudiesChange?: Dispatch<SetStateAction<Partial<IStudy>[] | undefined>>;
};

type KeyValueVisits = KeyValue<string> & { visits: IVisit[] };

const StudySelectFormInput = ({
  isInvalid,
  disabled,
  control,
  required = false,
  onStudiesChange,
}: StudySelectFormInputProps) => {
  const {
    state: { user },
  } = useAuthContext();
  const intl = useIntl();

  const [placeholder, setPlaceholder] = useState("");

  const [studies, setStudies] = useState<KeyValueVisits[]>([]);

  const loadingPlaceholder = intl.messages["GLOBAL.LOADING"] as string;
  const studyPlaceholder = intl.messages["STUDIES.STUDY_REQUIRED"] as string;

  useEffect(() => {
    setPlaceholder(`${loadingPlaceholder}...`);
    (async () => {
      if (!user?.organization?.id) return;
      const orgStudies = await studiesService.getStudies();
      if (!orgStudies?.studies) return;

      setStudies(
        orgStudies.studies.map((study) => ({
          key: study.id,
          value: study.name,
          visits: study.visits ?? [],
        })) ?? []
      );

      if (onStudiesChange) {
        const studies = orgStudies.studies.map((study) => ({
          id: study.id,
          name: study.name,
          visits: study.visits,
        }));

        onStudiesChange(studies);
      }

      setPlaceholder(studyPlaceholder);
    })();
  }, [
    loadingPlaceholder,
    studyPlaceholder,
    user?.organization?.id,
    onStudiesChange,
  ]);

  return (
    <SelectFormInput
      name={"study"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: studies,
        disabled: disabled,
        readOnly: disabled,
        isInvalid: isInvalid,
        placeholder: placeholder,
      }}
    />
  );
};
export default StudySelectFormInput;
